import {getTestProps} from '@benchling/js-test-utils';
import {Stack, Text, Title} from '@mantine/core';
import React from 'react';

import DataConnector from 'connect/DataConnector';

export interface ConnectedMoleculePredictedPropertiesTabProps {
  moleculeVersionId: string;
}

export interface UnconnectedMoleculePredictedPropertiesTabProps {
  moleculeId: string;
}

export type MoleculePredictedPropertiesTabProps = ConnectedMoleculePredictedPropertiesTabProps &
  UnconnectedMoleculePredictedPropertiesTabProps;

class MoleculePredictedPropertiesTabConnector extends DataConnector<
  UnconnectedMoleculePredictedPropertiesTabProps,
  ConnectedMoleculePredictedPropertiesTabProps
> {
  override readonly reduxSubscriptionPaths = ['ui.chemistry.moleculeVersionUIs'];

  enhanceProps(): ConnectedMoleculePredictedPropertiesTabProps {
    const moleculeVersionId =
      this.reduxState().ui.chemistry.moleculeVersionUIs[this.props.moleculeId].moleculeVersionId;
    return {moleculeVersionId};
  }
}

function MoleculePredictedPropertiesTab({
  moleculeId,
  moleculeVersionId,
}: MoleculePredictedPropertiesTabProps): JSX.Element {
  return (
    <div
      className="react-tab-container"
      role="region"
      aria-label="ADMET Predictions"
      {...getTestProps({
        component: 'MoleculePredictedPropertiesTab',
        element: 'root',
        key: `${moleculeId}-${moleculeVersionId}`,
      })}
    >
      <Stack spacing="sm">
        <Title order={2}>ADMET Predictions</Title>
        <Text component="p">ADMET predictions will appear here once a model has been run.</Text>
      </Stack>
    </div>
  );
}

const ConnectedMoleculePredictedPropertiesTab = MoleculePredictedPropertiesTabConnector.connect(
  MoleculePredictedPropertiesTab
);
export default ConnectedMoleculePredictedPropertiesTab;
